module.exports = __webpack_public_path__ + "media/img/clients-modal/join-b668f50724d843e47b66222219dd0d5b.svg";